<template>
  <div
    class="
      grid
      w-full
      h-full
      justify-center
      py-4
      content-center
      gap-4
      justify-items-center
    "
  >
    <img
      :src="require(`@/assets/${imageName}`)"
      alt="No Data Available"
      class="w-20 h-auto"
    />
    <p>{{ message }}</p>
  </div>
</template>
<script>
export default {
  name: 'NoDataAvailable',
  props: {
    imageName: {
      required: true,
      type: String,
    },
    message: {
      required: true,
      type: String,
    },
  },
};
</script>
